import { render } from "./ClassroomStudentsTable.vue?vue&type=template&id=a6f1c948"
import script from "./ClassroomStudentsTable.vue?vue&type=script&lang=js"
export * from "./ClassroomStudentsTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__